import { useTranslation } from "react-i18next";
import List from "Components/List/List";
import { IInventoryItemDto } from "Apis/Models/IInventoryItemDto";
import {formatNumber} from "../../../Utils/NumberUtils";
import FlexRow from "../../../Components/FlexRow";
import CheckmarkIcon from "../../../Assets/SVG/CheckmarkIcon";
import XIcon from "../../../Assets/SVG/XIcon";
import {useUnlistInventoryItem} from "../../../Apis/InventoryItemsApi";
import useToasts from "../../../Hooks/UseToasts";

interface IProps {
    inventoryItems?: IInventoryItemDto[];
    isLoading: boolean;
}
const InventoryItemsList = (props: IProps) => {

    const { t } = useTranslation();

    const { inventoryItems, isLoading } = props;

    const { showSuccessToast } = useToasts();

    const { mutateAsync: unlistInventoryItemMutation } = useUnlistInventoryItem();

    const toggleUnlisted = async (record: IInventoryItemDto) => {
        await unlistInventoryItemMutation(record);

        showSuccessToast(t('inventoryItemStatusChanged'));
    }

    return (
        <List<IInventoryItemDto> data={inventoryItems} loading={isLoading} columns={[
            {
                title: t('SKU'),
                textRender: (record) => record.sku
            },
            {
                title: t('name'),
                textRender: (record) => record.name
            },
            {
                title: t('unitPurchasePrice'),
                textRender: (record) => `${formatNumber(record.unitCostPrice)} DKK`
            },
            {
                title: t('status'),
                size: "min-content",
                customRender: (record) => (
                    <FlexRow align={"center"} style={{gap: 5}}>
                        {!record.unlisted ? <CheckmarkIcon /> : <XIcon />}
                        {record.unlisted ? t('unlisted') : t('listed')}
                    </FlexRow>
                )
            },
            {
                title: t('functions'),
                size: "min-content",
                customRender: (record) => (
                    <FlexRow justify={"center"} align={"center"}>
                        <FlexRow className={"clickable"} justify={"center"} align={"center"} title={record.unlisted ? t('relist') : t('unlist')} onClick={() => toggleUnlisted(record)}>
                            {record.unlisted ? <CheckmarkIcon /> : <XIcon />}
                        </FlexRow>
                    </FlexRow>
                )
            },
        ]} keyExtractor={(record) => record.id.toString()} />
    )
}

export default InventoryItemsList
